export default "__VITE_ASSET__Cel7t_Ef__"